module.exports = __webpack_public_path__ + "img/komunikaty_inactive.352a32c1.svg";